import { render, staticRenderFns } from "./SliderSemdifQuestion.vue?vue&type=template&id=34dca3c8&scoped=true"
import script from "./SliderSemdifQuestion.vue?vue&type=script&lang=js"
export * from "./SliderSemdifQuestion.vue?vue&type=script&lang=js"
import style0 from "./SliderSemdifQuestion.vue?vue&type=style&index=0&id=34dca3c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dca3c8",
  null
  
)

export default component.exports